//function to return an am/pm formatted string for a given integer input
export default(input) => {
  const hour = parseInt(input);
  switch (hour) {
    case 0:
    case 24:
      return '12 am';
    case 12:
      return '12 pm';

    default:
      if (isNaN(hour)) {
        return '';
      }
      if (hour < 12) {
        return `${hour} am`;
      } else {
        return `${hour % 12} pm`;
      }
  }
};
